import { useTranslation } from 'react-i18next';

import { Modal, ModalSize } from '@/components';
import {
  StyledModalContent,
  StyledGhostImage,
  StyledTitle,
  StyledMessage,
  StyledButton,
} from './PublishValidationModalStyles';

interface IPublishValidationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigateToPrice?: () => void;
}

const PublishValidationModal = ({ isOpen, onClose, onNavigateToPrice }: IPublishValidationModalProps) => {
  const { t } = useTranslation(['products']);

  const handleNavigateToPrice = () => {
    onClose();
    onNavigateToPrice?.();
  };

  return (
    <Modal visible={isOpen} onCancel={onClose} size={ModalSize.MEDIUM}>
      <StyledModalContent>
        <StyledGhostImage src="/images/ghost_smile.webp" alt="ghost" />
        <StyledTitle>{t('publish_validation_error_title')}</StyledTitle>
        <StyledMessage>{t('publish_validation_error_message')}</StyledMessage>
        {onNavigateToPrice && (
          <StyledButton onClick={handleNavigateToPrice}>{t('publish_validation_navigate_to_price')}</StyledButton>
        )}
      </StyledModalContent>
    </Modal>
  );
};

export default PublishValidationModal;
